/**
 * WhatsApp connection constants shared by the onboarding `WhatsAppConnect` step
 * and the dashboard `WhatsAppBusinessConnectionModal`.
 *
 * `WHATSAPP_CLOUD_VS_COEX_HELP_URL` points to the Help Center article that
 * explains the difference between Cloud API and Coexistencia so the user can
 * choose the option that fits their operation. The article exists only at the
 * `/es/` path today; en/br reuse the same URL until localized versions exist
 * (see RET-1324 plan, OQ1).
 */

export const WHATSAPP_CLOUD_VS_COEX_HELP_URL: string =
  'https://help.leadsales.io/es/articles/15364536-cloud-api-vs-coexistencia-cual-elegir-para-conectar-whatsapp-en-leadsales';
